var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"inputSeachContainer",staticClass:"aha-input-__wrapper w-full relative"},[_c('input',_vm._g({ref:"inputSearch",staticClass:"aha-input",class:[
      `aha-input-${_vm.size}`,
      {
        'rounded': _vm.rounded,
        'aha-input-limit': _vm.maxLength,
        'hover:border-primary-90 focus:border-primary-90': _vm.highlightOnHover,
        error: _vm.error,
      },
      _vm.classes
    ],attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"required":_vm.required,"autofocus":_vm.autofocus,"maxlength":_vm.maxLength,"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":_vm.handleInput,"keyup":_vm.handleKeyup,"focus":_vm.handleInputFocus,"blur":_vm.handleInputBlur}},_vm.listeners)),_c('aha-icon',{staticClass:"text-base-50 absolute right-2 top-2.5",attrs:{"name":"search","width":"18","height":"18","viewBox":"0 0 24 24"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }